<template>
	<div>
		<v-row justify="center" align="center" style="height: 70vh">
			<v-col cols="12" lg="5">
				<v-card class="px-12 py-8">
					<h3 class="mb-3 text-center">Login</h3>
					<v-form name="test" @submit.prevent="login">
						<v-text-field
							@focus="clearError"
							:error-messages="error"
							label="Brugernavn"
							v-model="username"
							autocomplete="off"
						/>
						<v-text-field
							@focus="clearError"
							:error-messages="error"
							type="password"
							label="Password"
							v-model="password"
						/>
						<div class="d-flex justify-space-between align-center mt-2">
                            <v-switch label="Login med Herobase" v-model="hbLogin" />
							<v-btn :loading="loading" type="submit">Login</v-btn>
						</div>
					</v-form>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	data() {
		return {
			username: "",
            password: "",
            hbLogin: false,
			error: [],
			loading: false
		};
    },
    computed: {
        access () {
            return this.$store.state.main.access
        }
    },
	methods: {
		async login() {
			this.error = [];
			this.loading = true;
			let login = await this.$store.dispatch("main/login", {
				username: this.username,
                password: this.password,
                hbLogin: this.hbLogin
			});
			if (login) {
                this.$store.dispatch("main/getConfig")
                if (this.access === 'all' || this.access === 'admin') this.$router.push("/stats/agents")
                else if (this.access === 'crm') this.$router.push('/reports/facebook')
                else if (this.access === 'tele') this.$router.push("/dashboard")
                else if (this.access === 'booking') this.$router.push("/booking/stats/sales")
                else if (this.access === 'naestved') this.$router.push("/naestved")
                else if (this.access === 'fh') this.$router.push("/fh")
                else if (this.access === 'pii') this.$router.push("/pii")
			} else {
				this.error.push("fejl i brugernavn eller password");
				this.loading = false;
			}
		},
		clearError() {
			this.error = [];
		}
	}
};
</script>